export default "__VITE_ASSET__DlbHFkeB__"